import { useEffect, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

import { LiveQuizJoinForm, LiveQuizParticipant } from '../components/livequiz';
import { useLiveQuizStore } from '../store/liveQuizStore';

const LiveQuizPlayPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const { session, myParticipantId, joinSession, resumeStoredSession, disconnect } = useLiveQuizStore();

    const [resuming, setResuming] = useState(true);

    useEffect(() => {
        let cancelled = false;
        resumeStoredSession()
            .catch(() => false)
            .finally(() => {
                if (!cancelled) {
                    setResuming(false);
                }
            });
        return () => {
            cancelled = true;
        };
    }, [resumeStoredSession]);

    useEffect(() => () => disconnect(), [disconnect]);

    if (resuming) {
        return (
            <div className="min-h-screen bg-slate-50 dark:bg-slate-950 grid place-items-center">
                <div className="w-8 h-8 rounded-full border-2 border-slate-200 dark:border-slate-700 border-t-teal-500 animate-spin" />
            </div>
        );
    }

    if (session && myParticipantId) {
        return <LiveQuizParticipant session={session} />;
    }

    return (
        <LiveQuizJoinForm
            initialJoinCode={searchParams.get('code') ?? ''}
            onJoin={async (joinCode, name) => {
                await joinSession(joinCode, name);
            }}
        />
    );
};

export default LiveQuizPlayPage;
